import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'

import { useCloseModal, useCurrentModal } from '../../../components/modals/ModalsContext'
import { serviceOrdersClient } from '../../../utils/apollo/api'
import { cleanRequest } from './cleanRequest'

const MUTATION = gql`
  mutation UpsertServiceOrder($input: ServiceOrderInput) {
    upsertServiceOrder(input: $input) {
      id
    }
  }
`
export const useSaveServiceOrder = () => {
  const notify = useNotification()
  const { data: log } = useCurrentModal()
  const closeModal = useCloseModal()
  const modal = useAlert()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['ServiceOrders', 'ServiceOrdersCount'],
    client: serviceOrdersClient
  })

  const handleRequest = async () => {
    if (!modal.confirm({ title: 'Tem certeza que deseja sobreescrever as respostas e concluir a atividade?' }))
      return false

    const input = cleanRequest(log.entity.id, log.data.payload)
    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: 'Atividade atualizada com sucesso!' })
        closeModal()
        return
      }
      notify.error({ title: 'Ocorreu um erro ao atualizar a atividade' })
    })
  }

  return [handleRequest, state]
}
